var map = {
	"./xun0.png": "GBKd",
	"./xun1.png": "EkSZ",
	"./xun2.png": "lpWq",
	"./xun3.png": "yWTu",
	"./xun4.png": "rAl+",
	"./xun5.png": "o/LY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9Eu9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home ^\.\/xun.*\.png$
// module id = 9Eu9
// module chunks = 0